import { useActivityData } from './UseActivityData';
import { NavBar, NavBarItem } from '../navbar';
import { useEffect, useState } from 'react';
import InvitationPage from '../../share/InvitationPage';

export default function ShareChatroom() {
  const { room } = useActivityData();
  const [inviteUrl, setInviteUrl] = useState('');

  useEffect(() => {
    if (!room) {
      return;
    }

    setInviteUrl(() => room.inviteUrl);
  }, [room]);

  return (
    <>
      <NavBar title={NavBarItem.SHARE} />
      <div className='h-8'></div>
      <InvitationPage inviteUrl={inviteUrl} />
    </>
  );
}
